export interface SortItem {
    order: SortingOrder;
    property: OrderPropery;
    name: OrderName;
}

export enum SortingOrder {
    DESC = 'DESC',
    ASC = 'ASC',
}

export enum OrderPropery {
    DATE = 'DATE',
    RELEVANCY = 'RELEVANCY',
}

export enum OrderName {
    DATE_DESC = 'scrape_date_desc',
    DATE_ASC = 'scrape_date_asc',
    RELEVANCY_DESC = 'relevant_probability_desc',
    RELEVANCY_ASC = 'relevant_probability_asc',
}
